<template>
  <div>
    <!--    <h1>Please provide your credit card details in order to proceed with payment.</h1>-->
    <stripe-elements
      ref="elementsRef"
      :pk="publishableKey"
      :amount="amount"
      @token="tokenCreated"
      @loading="loadingHandler"
    >
    </stripe-elements>
    <va-button class='pay-with-stripe my-0' @click="submit" :disabled='loading'>
      {{ $t('payment.payWithCreditCard') }}
      <RadarSpinner style="margin-left: 10px;" v-if="loading"
        :animation-duration="1000"
        :size="12"
        :color="this.$store.getters.config.palette.primary"
      />
    </va-button>
  </div>
</template>

<script>
import { RadarSpinner } from 'epic-spinners'
import { StripeElements } from 'vue-stripe-checkout'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'Stripe',
  components: { StripeElements, RadarSpinner },
  mixins: [errorHandlerMixin],
  data: () => ({
    loading: false,
    publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    token: null,
    charge: null,
    disabled: false,
    stripe: null,
    theloading: false,
  }),
  props: {
    subscriptionPlanInfoId: Number,
    amount: Number,
  },
  methods: {
    loadingHandler (state) {
      if (this.theloading && this.token != null) {
        this.loading = true
      } else {
        this.loading = state
      }
    },
    submit () {
      this.theloading = true
      this.$refs.elementsRef.submit()
    },
    tokenCreated (token) {
      this.token = token
      if (!this.token) {
        this.theloading = false
        this.loadingHandler(false)
      }
      this.charge = {
        source: token,
        amount: this.amount,
        description: this.description,
      }
      this.loading = true
      this.sendTokenToServer(this.charge)
    },
    async confirmCardPayment (response) {
      const clientSecret = response.clientSecret
      const status = response.stripeStatus

      if (clientSecret && status) {
        if (status === 'requires_action') {
          this.stripe.confirmCardPayment(clientSecret).then(async (result) => {
            if (result.error) {
              this.theloading = false
              this.loadingHandler(false)
              await this.errorHandler(this.$t('payment.paymentFailed'))
            } else {
              // overwrite payment on subscription before save
              // TODO return result.paymentIntent on success in order to know the proper data
              await this.completePayment(response)
            }
          })
        } else {
          await this.completePayment(response)
        }
      }
    },
    async paymentActions (response) {
      if (response.isCompleted) {
        await this.completePayment(response)
      } else {
        await this.confirmCardPayment(response)
      }
    },
    async sendTokenToServer (charge) {
      this.stripe = window.Stripe(this.publishableKey)
      await this.$store.dispatch('makePayment', {
        subscriptionPlanInfoId: this.subscriptionPlanInfoId,
        paymentMethodId: charge.source.id,
        amount: this.amount,
      }).then((resp) => this.paymentActions(resp.data.message))
        .catch(error => {
          this.errorHandler(error.response)
          this.theloading = false
          this.loadingHandler(false)
        })
    },
    async completePayment (response) {
      await this.$store.dispatch('completePayment', {
        paymentId: response.paymentId,
        stripeCustomerId: response.stripeCustomerId,
        stripeInvoiceId: response.stripeInvoiceId,
        isCompleted: true,
        subscription: JSON.stringify(response.subscription),
      }).then((resp) => this.$router.push({
        name: 'payment-completed',
        params: { paymentId: resp.data.message.paymentId },
      })).catch(error => {
        this.errorHandler(error.response)
        this.theloading = false
        this.loadingHandler(false)
      })
    },
  },
}
</script>
